/**
 * Kennzeichnet den ausgelieferten Stand: der Zeitpunkt des Baus, von Vite eingesetzt.
 *
 * Steht in den Einstellungen, weil sich sonst nicht feststellen lässt, welcher Stand
 * auf einem Gerät läuft — genau daran ist eine Fehlersuche schon einmal vorbeigelaufen:
 * Der Schreibtisch zeigte tagelang eine alte Fassung, und niemand konnte es sehen.
 */
declare const __ATHENE_BUILD__: string;

export const BUILD = typeof __ATHENE_BUILD__ === 'string' ? __ATHENE_BUILD__ : 'unbekannt';

/**
 * Der Stand, den der Server gerade ausliefert. Kommt bewusst an Cache und Service
 * Worker vorbei: Weicht er von {@link BUILD} ab, hält dieses Gerät eine alte Fassung
 * fest. Stimmt er überein und fehlt trotzdem etwas, ist der Server nicht neu gebaut.
 */
export async function serverFassung(): Promise<{ gebaut: string; commit: string } | null> {
  try {
    const antwort = await fetch('/fassung.txt', { cache: 'no-store' });
    if (!antwort.ok) return null;
    return (await antwort.json()) as { gebaut: string; commit: string };
  } catch {
    return null;
  }
}
